/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SubscribeMarketingConsentDTO } from '../dto';
// @ts-ignore
import type { ValidationErrorResponseDTO } from '../dto';
/**
 * UserMarketingApi - axios parameter creator
 * @export
 */
export const UserMarketingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Subscribes a user to marketing by giving consent
         * @param {string} userId 
         * @param {SubscribeMarketingConsentDTO} subscribeMarketingConsentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveMarketingConsent: async (userId: string, subscribeMarketingConsentDTO: SubscribeMarketingConsentDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('giveMarketingConsent', 'userId', userId)
            // verify required parameter 'subscribeMarketingConsentDTO' is not null or undefined
            assertParamExists('giveMarketingConsent', 'subscribeMarketingConsentDTO', subscribeMarketingConsentDTO)
            const localVarPath = `/users/{userId}/marketing/giveMarketingConsent`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeMarketingConsentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserMarketingApi - functional programming interface
 * @export
 */
export const UserMarketingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserMarketingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Subscribes a user to marketing by giving consent
         * @param {string} userId 
         * @param {SubscribeMarketingConsentDTO} subscribeMarketingConsentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giveMarketingConsent(userId: string, subscribeMarketingConsentDTO: SubscribeMarketingConsentDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giveMarketingConsent(userId, subscribeMarketingConsentDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserMarketingApi.giveMarketingConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserMarketingApi - factory interface
 * @export
 */
export const UserMarketingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserMarketingApiFp(configuration)
    return {
        /**
         * 
         * @summary Subscribes a user to marketing by giving consent
         * @param {UserMarketingApiGiveMarketingConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveMarketingConsent(requestParameters: UserMarketingApiGiveMarketingConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.giveMarketingConsent(requestParameters.userId, requestParameters.subscribeMarketingConsentDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for giveMarketingConsent operation in UserMarketingApi.
 * @export
 * @interface UserMarketingApiGiveMarketingConsentRequest
 */
export interface UserMarketingApiGiveMarketingConsentRequest {
    /**
     * 
     * @type {string}
     * @memberof UserMarketingApiGiveMarketingConsent
     */
    readonly userId: string

    /**
     * 
     * @type {SubscribeMarketingConsentDTO}
     * @memberof UserMarketingApiGiveMarketingConsent
     */
    readonly subscribeMarketingConsentDTO: SubscribeMarketingConsentDTO
}

/**
 * UserMarketingApi - object-oriented interface
 * @export
 * @class UserMarketingApi
 * @extends {BaseAPI}
 */
export class UserMarketingApi extends BaseAPI {
    /**
     * 
     * @summary Subscribes a user to marketing by giving consent
     * @param {UserMarketingApiGiveMarketingConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMarketingApi
     */
    public giveMarketingConsent(requestParameters: UserMarketingApiGiveMarketingConsentRequest, options?: RawAxiosRequestConfig) {
        return UserMarketingApiFp(this.configuration).giveMarketingConsent(requestParameters.userId, requestParameters.subscribeMarketingConsentDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

